import { type CampaignProducts2BResponse, type CampaignProductsListResponse } from '@hooks-api/types/apiResponse'
import { type Coupon } from '@hooks-api/types/dataModel/coupon'
import { type AllProduct } from '@hooks-api/types/dataModel/products'
import { type AllProductDTO, type CampaignProductCatalogDTO, type FpB2bProductCatalogDTO } from '../types'
import { groupVariationsByFirstLevelButton } from '../utils/groupVariationsByFirstLevelButton'

const convertAllProduct = (allProduct: AllProduct): AllProductDTO => {
  const variations = allProduct.group.flatMap(group => group.variations)
  return {
    ...allProduct,
    variations,
    variationsGroupByFirstLevelButton: groupVariationsByFirstLevelButton(variations),
  }
}

const convertProducts = (products: {
  tab_display_name: string
  coupon_ids: Coupon['id'][]
  all_product: AllProduct[]
}[]) => products.map(product => ({
  ...product,
  all_product: product.all_product.map(convertAllProduct),
}))

export const fpConvertB2bProductCatalogDTO = (response: CampaignProducts2BResponse): FpB2bProductCatalogDTO => {
  const { products, additions, ...rest } = response.data

  return {
    ...rest,
    products: convertProducts(products),
    additions: convertProducts(additions),
  }
}

export const fpConvertCampaignProductCatalogDTO = (response: CampaignProductsListResponse): CampaignProductCatalogDTO => {
  const { products, additions, ...rest } = response.data

  return {
    ...rest,
    products: convertProducts(products),
    additions: convertProducts(additions),
  }
}
